import apis from './apis';

export default {
  apis,
};
